import { createAction } from "redux-actions";

export const NEW_VALUE = "NEW_VALUE";

export const SAVED_SEARCH_SELECTED = "SAVED_SEARCH_SELECTED";
export const savedSearchSelected = createAction(SAVED_SEARCH_SELECTED);

// Actions related to clicking Save Search and getting the options for the Save Search overlay
export const SAVED_SEARCH_OPTIONS_TRIGGER = "SAVED_SEARCH_OPTIONS_TRIGGER";
export const savedSearchOptionsTrigger = createAction(SAVED_SEARCH_OPTIONS_TRIGGER);

export const SAVED_SEARCH_OPTIONS_START = "SAVED_SEARCH_OPTIONS_START";
export const savedSearchOptionsStart = createAction(SAVED_SEARCH_OPTIONS_START);

export const SAVED_SEARCH_OPTIONS_RESPONSE_RECEIVED = "SAVED_SEARCH_OPTIONS_RESPONSE_RECEIVED";
export const savedSearchOptionsResponseReceived = createAction(SAVED_SEARCH_OPTIONS_RESPONSE_RECEIVED);

export const SAVED_SEARCH_OPTIONS_FINISHED = "SAVED_SEARCH_OPTIONS_FINISHED";
export const savedSearchOptionsFinished = createAction(SAVED_SEARCH_OPTIONS_FINISHED);

export const DOWNLOAD_SAVED_SEARCH_OPTIONS_TRIGGER = "DOWNLOAD_SAVED_SEARCH_OPTIONS_TRIGGER";
export const downloadSavedSearchTrigger = createAction(DOWNLOAD_SAVED_SEARCH_OPTIONS_TRIGGER);

// Actions related to submitting the Save Search overlay
export const SAVED_SEARCH_SUBMIT_TRIGGER = "SAVED_SEARCH_SUBMIT_TRIGGER";
export const savedSearchSubmitTrigger = createAction(SAVED_SEARCH_SUBMIT_TRIGGER);

export const SAVED_SEARCH_SUBMIT_START = "SAVED_SEARCH_SUBMIT_START";
export const savedSearchSubmitStart = createAction(SAVED_SEARCH_SUBMIT_START);

export const SAVED_SEARCH_SUBMIT_RESPONSE_RECEIVED = "SAVED_SEARCH_SUBMIT_RESPONSE_RECEIVED";
export const savedSearchSubmitResponseReceived = createAction(SAVED_SEARCH_SUBMIT_RESPONSE_RECEIVED);

export const SAVED_SEARCH_SUBMIT_FINISHED = "SAVED_SEARCH_SUBMIT_FINISHED";
export const savedSearchSubmitFinished = createAction(SAVED_SEARCH_SUBMIT_FINISHED);

export const SAVED_SEARCH_SUBMIT_CANCEL = "SAVED_SEARCH_SUBMIT_CANCEL";
export const savedSearchSubmitCancel = createAction(SAVED_SEARCH_SUBMIT_CANCEL);

export const SAVED_SEARCH_SUBMIT_RADIO_BUTTON_CLICKED = "SAVED_SEARCH_SUBMIT_RADIO_BUTTON_CLICKED";
export const savedSearchSubmitRadioButtonClicked = createAction(SAVED_SEARCH_SUBMIT_RADIO_BUTTON_CLICKED);

export const SAVED_SEARCH_SUBMIT_TEXT_CHANGE = "SAVED_SEARCH_SUBMIT_TEXT_CHANGE";
export const savedSearchSubmitTextChange = createAction(SAVED_SEARCH_SUBMIT_TEXT_CHANGE);
